var DEBUG_INFO_SERVICE__COMPONENT_LIBRARY = '@insiderintelligence/componentlibrary';
var DEBUG_INFO_SERVICE__GAM = '@insiderintelligence/googleadmanager';
var DEBUG_INFO_SERVICE__UTILITY_DATALAYER = '@insiderintelligence/datalayer';
var DEBUG_INFO_SERVICE__UTILITY_DEBUGINFO = '@insiderintelligence/debuginfo';
var DEBUG_INFO_SERVICE__UTILITY_SEO_UTILS = '@insiderintelligence/seo-utilities';
var DEBUG_INFO_SERVICE__CODE_HELPERS = '@emarketer/code-helpers';
var DEBUG_INFO_SERVICE__PRETTIER_CONFIG = '@insiderintelligence/prettierconfig';
var DEBUG_INFO_SERVICE__QA_CODE_HELPERS = '@insiderintelligence/qa-code-helpers';
/**
 * add other imports/dependencies from THIS SERVICE's "package.json" that we care about to know the version for (name must match exactly to that in "package.json")
 */
var PACKAGES_THAT_MATTER = [DEBUG_INFO_SERVICE__COMPONENT_LIBRARY, DEBUG_INFO_SERVICE__GAM, DEBUG_INFO_SERVICE__UTILITY_DATALAYER, DEBUG_INFO_SERVICE__UTILITY_DEBUGINFO, DEBUG_INFO_SERVICE__UTILITY_SEO_UTILS, DEBUG_INFO_SERVICE__PRETTIER_CONFIG, DEBUG_INFO_SERVICE__CODE_HELPERS, DEBUG_INFO_SERVICE__QA_CODE_HELPERS];
/**
 * If this cookie found && ==true, it's a sign to this widget to display debug info on the page
 */
var DEBUG_INFO_SERVICE__COOKIE_IS_VISIBLE = 'em_debug_info_show';
/**
 * id of the <div> where debug info for services would be shown
 */
var HTML_DIV_ID_DEBUG_INFO_POPUP = 'em-debug-info-popup';
var HTML_DIV_DATA_ATTRIB_SVC_INFO = 'data-em-debug-info-svc';
var HTML_DIV_ID_DEBUG_INFO_DATA_WRAPPER = 'em-debug-info-data-wrapper';
/**
 * This would help us "attach" the "dependencies" to a "parent" (host) service
 * e.g. we can identify that '@insiderintelligence/componentlibrary' is a dependency of "public.editorialassets" vs. "public.noteworthycontent"
 */
var HTML_DIV_DATA_ATTRIB_HOST_SVC_INFO = 'data-em-debug-info-host-svc';
var HTML_DIV_CSS_CLASS = 'emDebugInfoWrapper';
var HTML_DIV_SVC_DEPENDENCY_CSS_CLASS = 'emDebugInfoDependency';
var HTML_DIV_DISMISS_BUTTON_WRAPPER_CSS_CLASS = 'emDebugInfoDismissBtnWrapper';
var HTML_BUTTON_DISMISS_CSS_CLASS = 'emDebugInfoDismissBtn';
var JS_INLINE_TAG_ID = 'emDebugInfoScripts';
var CSS_INLINE_TAG_ID = 'emDebugInfoStyles';
var CSS_INLINE = "\n  ." + HTML_DIV_CSS_CLASS + "{font-size:10px;font-family: monospace;position: fixed;bottom: 10px;left: 10px;color: #61de2a;z-index: 2147483647;padding: 15px;} \n  ." + HTML_DIV_CSS_CLASS + ":hover{background-color: black; font-size: 22px;border-radius: 10px;}\n  ." + HTML_DIV_SVC_DEPENDENCY_CSS_CLASS + "{margin-left:10px;}\n  ." + HTML_DIV_DISMISS_BUTTON_WRAPPER_CSS_CLASS + "{text-align: right;}\n  ." + HTML_BUTTON_DISMISS_CSS_CLASS + "{text-decoration:none;color:#D3D3D3;text-decoration: underline;cursor:pointer;}\n  ." + HTML_BUTTON_DISMISS_CSS_CLASS + ":visited{color: #D3D3D3;}\n  ";

var generateDebugInfoList = function generateDebugInfoList(debugInfoArray) {
  var htmlElements = [];
  debugInfoArray.forEach(function (item) {
    var newElement = generateDebugInfoItem(item);
    //htmlMarkup += newElement.outerHTML;
    htmlElements.push(newElement);
  });
  return htmlElements;
};
/**
 * NOTE: goes together with "dismiss" script in "ShowServiceDebugInfo.tsx"
 * @returns
 */
var generateDismissButtonsSection = function generateDismissButtonsSection() {
  var dismiss = document.createElement('a');
  dismiss.className = HTML_BUTTON_DISMISS_CSS_CLASS;
  dismiss.setAttribute('onclick', 'dismissSvcDebugInfo(event)');
  dismiss.title = 'This will dismiss until next refresh';
  dismiss.textContent = 'Dismiss';
  var dismissPermanently = document.createElement('a');
  dismissPermanently.className = HTML_BUTTON_DISMISS_CSS_CLASS;
  dismissPermanently.setAttribute('onclick', 'dismissSvcDebugInfoPermanently(event)');
  dismissPermanently.title = "This will dismiss until you remove the [" + DEBUG_INFO_SERVICE__COOKIE_IS_VISIBLE + "=false] cookie";
  dismissPermanently.textContent = 'Permanently';
  var newSvcDiv = document.createElement('div');
  newSvcDiv.setAttribute('class', HTML_DIV_DISMISS_BUTTON_WRAPPER_CSS_CLASS);
  newSvcDiv.appendChild(dismiss);
  newSvcDiv.innerHTML += '&nbsp;|&nbsp;';
  newSvcDiv.appendChild(dismissPermanently);
  return newSvcDiv;
};
/**
 * Get the DebugInfo record and convert it to html markup
 * @param item DebugInfo record to convert to html markup
 * @returns
 */
var generateDebugInfoItem = function generateDebugInfoItem(item) {
  var newSvcDiv = document.createElement('div');
  newSvcDiv.setAttribute(HTML_DIV_DATA_ATTRIB_SVC_INFO, item.serviceName);
  newSvcDiv.setAttribute(HTML_DIV_DATA_ATTRIB_HOST_SVC_INFO, item.parentServiceName ? item.parentServiceName : '');
  newSvcDiv.setAttribute('class', item.isDependency ? HTML_DIV_SVC_DEPENDENCY_CSS_CLASS : '');
  newSvcDiv.innerHTML = "<strong>" + item.serviceName + "</strong>: " + item.releaseVersion;
  return newSvcDiv;
};
var generateCssStylesContainer = function generateCssStylesContainer() {
  var styleContainer = document.createElement('style');
  styleContainer.id = CSS_INLINE_TAG_ID;
  styleContainer.innerHTML = CSS_INLINE;
  return styleContainer;
};
var generateScriptContainer = function generateScriptContainer() {
  var scriptContainer = document.createElement('script');
  scriptContainer.id = JS_INLINE_TAG_ID;
  scriptContainer.innerHTML = "\n      function dismissSvcDebugInfo(e) {\n          e.preventDefault();\n          var div = document.getElementById('" + HTML_DIV_ID_DEBUG_INFO_POPUP + "');\n          div.parentNode.removeChild(div);\n          const css = document.getElementById(" + CSS_INLINE_TAG_ID + ");\n          if (css) {\n            document.head.removeChild(css);\n          }\n          const js = document.getElementById(" + JS_INLINE_TAG_ID + ");\n          if (js) {\n            document.head.removeChild(js);\n          }\n      };\n      function dismissSvcDebugInfoPermanently(e) {\n          dismissSvcDebugInfo(e);\n          document.cookie = \"" + DEBUG_INFO_SERVICE__COOKIE_IS_VISIBLE + "=false; path=/\";\n      }\n      ";
  return scriptContainer;
};
var generateDebugInfoDataContainer = function generateDebugInfoDataContainer(serviceInfoArray) {
  var debugInfoDataContainer = document.createElement('div');
  debugInfoDataContainer.setAttribute('id', HTML_DIV_ID_DEBUG_INFO_DATA_WRAPPER);
  var elements = generateDebugInfoList(serviceInfoArray);
  elements.forEach(function (element) {
    debugInfoDataContainer.appendChild(element);
  });
  return debugInfoDataContainer;
};
var generateMainWrapperContainer = function generateMainWrapperContainer(elements) {
  var debugInfoBubble = document.createElement('div');
  debugInfoBubble.setAttribute('id', HTML_DIV_ID_DEBUG_INFO_POPUP);
  debugInfoBubble.setAttribute('class', HTML_DIV_CSS_CLASS);
  //debugInfoBubble.innerHTML = elements.join('');
  elements.forEach(function (element) {
    debugInfoBubble.appendChild(element);
  });
  return debugInfoBubble;
};

/**
 * This function groups service info and its dependencies into one array
 * @param thisServiceInfo "main" service info, e.g. "public.editorialassets"
 * @param serviceDependencies dependencies of the "main" service
 * @returns unified flat array of service info including main service and its dependencies
 */
var groupSvcAndDependencies = function groupSvcAndDependencies(thisServiceInfo, serviceDependencies) {
  var serviceInfoArray = [];
  // add "host" service info (host service is the one that "owns" current page, e.g. "public.editorialassets" or "public.forecasts" etc.)
  serviceInfoArray.push(thisServiceInfo);
  // add dependencies (if any)
  if (serviceDependencies) {
    serviceDependencies.forEach(function (svc) {
      if (svc.isDependency) {
        svc.parentServiceName = thisServiceInfo.serviceName;
      }
    });
    serviceInfoArray.push.apply(serviceInfoArray, serviceDependencies);
  }
  return serviceInfoArray;
};

/**
 * This function pushes the data about services into special <div> and then displays it in browser's bottom left corner
 * @param thisServiceInfo - info about this service
 * @param serviceDependencies - info about this service's dependencies (use one of the **getSvcDependencies..** methods in DebugInfo packgage to extract those)
 * @param isShowConsoleLogs - set this to "true" if you want to see console.logs from "DebugInfo" package (helful when troubleshooting)
 * @returns
 */
var showServiceDebugInfo = function showServiceDebugInfo(thisServiceInfo, serviceDependencies, isShowConsoleLogs) {
  var serviceInfoArray = groupSvcAndDependencies(thisServiceInfo, serviceDependencies);
  //#region debug logs
  if (isShowConsoleLogs) {
    console.log('DEBUG (DebugInfo.ShowServiceDebugInfo): thisServiceInfo: ', thisServiceInfo ? JSON.stringify(thisServiceInfo) : 'EMPTY', ';.. dependencies: ', serviceDependencies ? JSON.stringify(serviceDependencies) : 'EMPTY');
    console.log('DEBUG (DebugInfo.ShowServiceDebugInfo): ...serviceInfoArray: ', JSON.stringify(serviceInfoArray));
  }
  //#endregion debug logs
  if (typeof window !== 'undefined') {
    // see if div with "Service Debug Info" already exists on the page
    var existingListDiv = document.getElementById(HTML_DIV_ID_DEBUG_INFO_DATA_WRAPPER);
    //#region debug logs
    if (isShowConsoleLogs) {
      console.log('DEBUG (DebugInfo.ShowServiceDebugInfo): existingListDiv:', existingListDiv);
    }
    //#endregion debug logs
    if (existingListDiv) {
      // if div already exists on the page, then see if info about current service should be appended (if doesn't exist)
      var newSvcInfoToAdd = [];
      // Loop through each child div to see if we already have info on that svc
      serviceInfoArray.forEach(function (svc) {
        if (!existingListDiv.querySelector("div[" + HTML_DIV_DATA_ATTRIB_SVC_INFO + "=\"" + svc.serviceName + "\"]")) {
          newSvcInfoToAdd.push(svc);
        }
      });
      if (newSvcInfoToAdd.length > 0) {
        newSvcInfoToAdd.forEach(function (svc) {
          existingListDiv.appendChild(generateDebugInfoItem(svc));
        });
      }
      return;
    } else {
      // if div doesn't exist on the page, add it
      // STYLE
      document.head.appendChild(generateCssStylesContainer());
      // SCRIPTS
      document.head.appendChild(generateScriptContainer());
      // PARENT WRAPPER DIV
      var itemsInsideMainWrapperDiv = [generateDebugInfoDataContainer(serviceInfoArray), generateDismissButtonsSection()];
      document.body.appendChild(generateMainWrapperContainer(itemsInsideMainWrapperDiv));
      return;
    }
  }
};

/**
 * Checks if either a *special cookie* or a *special query string param* exist AND if environment is non-prod
 * @param currentEnvironment
 * @param req i.e. the context.req in "getInitialProps" (if check is run server-side), pass "null" if running a check CLIENT-SIDE
 * @param isShowConsoleLogs - set to "true" if you want to see logs for debugging
 * @returns
 */
function isShowServiceDebugInfo(currentEnvironment, req, isShowConsoleLogs) {
  //#region DEBUG LOGGING
  if (isShowConsoleLogs) {
    console.log("DEBUG (DebugInfo.isShowServiceDebugInfo): currentEnvironment: ", currentEnvironment);
  }
  //#endregion DEBUG LOGGING
  if (req) {
    var _req$headers;
    // if we have `req` object (server-side) - check for cookie
    var cookieValue = getCookieFromReqHeaders((_req$headers = req.headers) == null ? void 0 : _req$headers.cookie, DEBUG_INFO_SERVICE__COOKIE_IS_VISIBLE);
    //#region DEBUG LOGGING
    if (isShowConsoleLogs) {
      console.log("DEBUG (DebugInfo.isShowServiceDebugInfo) SERVER-SIDE: cookie value: " + cookieValue);
    }
    //#endregion DEBUG LOGGING
    if (cookieValue === 'true') {
      return true; // only return "true" if explicitly requested by user (it might be PROD)
    } else if (cookieValue === 'false') {
      return false; // explicitly requested to hide
    }
  } else if (typeof window !== 'undefined') {
    // client-side check
    var _cookieValue = getCookieFromWindow(DEBUG_INFO_SERVICE__COOKIE_IS_VISIBLE);
    //#region DEBUG LOGGING
    if (isShowConsoleLogs) {
      console.log("DEBUG (DebugInfo.isShowServiceDebugInfo) CLIENT-SIDE: cookie [" + DEBUG_INFO_SERVICE__COOKIE_IS_VISIBLE + "] value: " + _cookieValue);
    }
    //#endregion DEBUG LOGGING
    if (_cookieValue === 'true') {
      return true; // only return "true" if explicitly requested by user (it might be PROD)
    } else if (_cookieValue === 'false') {
      return false; // explicitly requested to hide
    }
  }

  if (['local', 'development', 'staging'].includes(currentEnvironment != null ? currentEnvironment : '')) {
    return true;
  }
  return false; // skip by default
}

function getCookieFromWindow(key) {
  var _window$document;
  var b = (_window$document = window.document) == null ? void 0 : _window$document.cookie.match('(^|;)\\s*' + key + '\\s*=\\s*([^;]+)');
  return b ? b.pop() : '';
}
function getCookieFromReqHeaders(reqHeadersCookieString, key) {
  var regex = new RegExp("(?:^|; )" + key + "=([^;]*)");
  var matches = regex.exec(reqHeadersCookieString);
  if (matches) {
    return decodeURIComponent(matches[1]);
  }
  return null;
}

function sanitizePackageName(packageName) {
  return packageName.replace('@', '_').replace('/', '_').replace('-', '_');
}

/**
 * Pass a "package.json > dependencies" object here, and this method will return versions of all dependencies we care about
 * @param packageJsonDependencies - **dependencies** from **package.json** file in your project
 * @param isShowConsoleLogs - set this to "true" if you want to see console.logs from "DebugInfo" package (helful when troubleshooting)
 * @returns array of **IServiceDebugInfo** objects
 */
function getSvcDependenciesFromPackageJson(packageJsonDependencies, isShowConsoleLogs) {
  var dependencies = [];
  //#region DEBUG LOGGING
  if (isShowConsoleLogs) {
    console.log("DEBUG (DebugInfo.getSvcDependenciesFromPackageJson): dependencies " + JSON.stringify(packageJsonDependencies) + "...");
  }
  //#endregion DEBUG LOGGING
  PACKAGES_THAT_MATTER.forEach(function (pkg_name) {
    //#region DEBUG LOGGING
    if (isShowConsoleLogs) {
      console.log("DEBUG (DebugInfo.getSvcDependenciesFromPackageJson): PACKAGES_THAT_MATTER[pkg_name]: " + pkg_name);
    }
    //#endregion DEBUG LOGGING
    var pkg_version = packageJsonDependencies[pkg_name];
    // if info about these packages doesn't exist in dependencies, add it
    if (dependencies.length == 0 || dependencies.map(function (e) {
      return e.serviceName;
    }).indexOf(pkg_name) < 0) {
      if (pkg_version) {
        //#region DEBUG LOGGING
        if (isShowConsoleLogs) {
          console.log("DEBUG (DebugInfo.getSvcDependenciesFromPackageJson):  pkg_version: " + pkg_version + " found!");
        }
        //#endregion DEBUG LOGGING
        var newServiceDebugInfo = {
          serviceName: pkg_name,
          releaseVersion: pkg_version
        };
        dependencies.push(newServiceDebugInfo); //
      }
    }
  });

  return dependencies;
}
/**
 *
 * Pulls service denedencies from SERVER-SIDE process.env object, which has the following format:
 * { ..., "npm_package_dependencies__insiderintelligence_componentlibrary": "1.0.664", "npm_package_devDependencies_prettier": "^2.5.1", ...}
 * WILL ONLY WORK SERVER-SIDE, ie. in *Component.getInitialProps()* or *Component.getServerSideProps()* where process.env.*** is actually available
 * @param processDotEnv server-side process.env object - just pass it as-is, and this method will pull the dependencies we care about
 * @param isShowConsoleLogs - set this to "true" if you want to see console.logs from "DebugInfo" package (helful when troubleshooting)
 * @returns array of IServiceDebugInfo objects
 */
function getSvcDependenciesFromProcessEnv(processDotEnv, isShowConsoleLogs) {
  var dependencies = [];
  //#region DEBUG LOGGING
  if (isShowConsoleLogs) {
    console.log("DEBUG (DebugInfo.getSvcDependenciesFromProcessEnv): ACTUAL process.env " + JSON.stringify(process.env));
    console.log("DEBUG (DebugInfo.getSvcDependenciesFromProcessEnv):  INPUT PARAMETER processDotEnv " + JSON.stringify(processDotEnv));
  }
  //#endregion DEBUG LOGGING
  PACKAGES_THAT_MATTER.forEach(function (pkg_name) {
    // if info about these packages doesn't exist in window.ii_service_info, add it
    if (dependencies.length == 0 || dependencies.map(function (e) {
      return e.serviceName;
    }).indexOf(pkg_name) < 0) {
      // if value (version) for this package found in process.env (retrieved automatically from package.json "depeendencies"), push info window.ii_service_info array, so it can be extracted & displayed
      var sanitizedPkgName = sanitizePackageName(pkg_name);
      //#region DEBUG LOGGING
      if (isShowConsoleLogs) {
        console.log("DEBUG (DebugInfo.getSvcDependenciesFromProcessEnv): sanitizedPkgName: " + sanitizedPkgName);
      }
      //#endregion DEBUG LOGGING
      var name = "npm_package_dependencies_" + sanitizedPkgName;
      var pkg_version = processDotEnv[name];
      //#region DEBUG LOGGING
      if (isShowConsoleLogs) {
        console.log("DEBUG (DebugInfo.getSvcDependenciesFromProcessEnv): adding " + name + ": " + pkg_version);
      }
      //#endregion DEBUG LOGGING
      if (pkg_version) {
        var newServiceDebugInfo = {
          serviceName: pkg_name,
          releaseVersion: pkg_version,
          isDependency: true
        };
        dependencies.push(newServiceDebugInfo); //
      }
    }
  });

  return dependencies;
}

export { getSvcDependenciesFromPackageJson, getSvcDependenciesFromProcessEnv, isShowServiceDebugInfo, showServiceDebugInfo };
//# sourceMappingURL=debuginfo.esm.js.map
